import { styled } from "@mui/material";
import { Card, ClipboardCopy, Tag } from "@volt_developers/components";
import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import {
  getPixFormattedValue,
  mapPixTypeToTranslation,
  PIX as PIXType,
} from "modules/bank-accounts";

import { CARDS_TEST_IDS } from "../../../constants";

export interface PIXProps {
  "data-testid"?: string;
  label?: string;
  pix?: PIXType | null;
}

export function PIX({ pix, label, "data-testid": dataTestId }: PIXProps) {
  const { t } = useTranslation(["common", "bankAccounts"]);

  if (!pix) {
    return null;
  }

  return (
    <Card.Item
      data-testid={dataTestId ?? CARDS_TEST_IDS.pixItem}
      label={label ?? t(COMMON_TRANSLATION_KEYS.pixKey, { ns: "common" })}
    >
      <Wrapper>
        <Tag
          label={t(mapPixTypeToTranslation(pix.type), { ns: "bankAccounts" })}
          sx={{ mr: 1 }}
        />
        <ClipboardCopy>{getPixFormattedValue(pix)}</ClipboardCopy>
      </Wrapper>
    </Card.Item>
  );
}

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
});
